export default __webpack_public_path__ + "static/media/kds_icon.4c53006a.svg";